import { appFormUtil } from 'modules/common';
import { StyledDropDown } from 'modules/components/layer01';
import React from 'react';
import * as ds from './dataService';
import { useParams } from 'react-router-dom';


export type PersonsInAccidentSelectFieldProps<T extends object> = appFormUtil.SelectFieldProps<T> & {};


/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = <T extends object>(props: PersonsInAccidentSelectFieldProps<T>) => {
  const params = useParams();
  const { data } = ds.useQuery(params.projectId ?? '');
  // const handleSelectMultiple = (e: SelectChangeEvent<unknown>) => {
  //   if (_.isArray(props.form.formState[props.fieldName])) {
  //     const fieldArray = props.form.formState[props.fieldName] as Array<string>;
  //     const exists = fieldArray.find((node) => node === e.target.value);
  //     if (exists) {
  //       const tempArray = fieldArray.filter((rec) => rec !== e.target.value);
  //       props.form.dispatch({
  //         type: 'UPDATE',
  //         payload: {
  //           property: props.fieldName,
  //           value: e.target.value as T[keyof T]
  //         }
  //       });
  //     } else {
  //       props.form.dispatch({
  //         type: 'UPDATE',
  //         payload: {
  //           property: props.fieldName,
  //           value: e.target.value as T[keyof T]
  //         }
  //       });
  //     }
  //   }
  // };

  return (
    <StyledDropDown.FC
      {...props.form.genFieldProps(props.fieldName)}
      multiple
      options={
        [...data]
      }

    />
  );
};

